'use client'

import { useEffect } from 'react'
import { Button } from '@repo/ui/button'
import { RefreshCw } from 'lucide-react'
import * as Sentry from '@sentry/nextjs'
import { TableState } from '@/components/ui/TableState'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <TableState
      title="An unexpected error occurred."
      description="Please refresh the page."
      lottieSrc="/animations/connectivity-issues.json"
      lottieStyle={{ width: '250px', height: '200px' }}
      className="h-screen"
      action={
        <Button variant="outline" className="gap-2 py-3" onClick={() => window.location.reload()}>
          <RefreshCw size={16} />
          <p className="text-base font-medium">Refresh Page</p>
        </Button>
      }
    />
  )
}
